import React from 'react';
import { NavLink, Route, Switch, Redirect } from 'react-router-dom';
import Sponsors from './Sponsors';
import Prizes from './Prizes';
import Establishments from './Establishments';
import Setup from './Setup';
import PrizeDraws from './PrizeDraws';
import RaffleImages from './RaffleImages/RaffleImages';
import CustomerSupport from './CustomerSupport';
import Reports from './Reports';
import { FormattedMessage } from 'react-intl';

const WorldCup: React.FC = () => {
  if (window.location.pathname === '/dashboard/worldcup') {
    return <Redirect to={'/dashboard/worldcup/sponsors'} />;
  }

  return (
    <div className="worldCup_header_layout">
      <div className="worldCup_config_header_wrapper">
        <div className="sar_config_list_header">
          <div className="header_title">
            <FormattedMessage id="World Cup" />
          </div>
        </div>
        <div className="menu_items">
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/sponsors'} activeClassName={'active'}>
              <FormattedMessage id={'Sponsors'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/establishments'} activeClassName={'active'}>
              <FormattedMessage id={'Establishments'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/prizes'} activeClassName={'active'}>
              <FormattedMessage id={'Prizes'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/setup'} activeClassName={'active'}>
              <FormattedMessage id={'Setup'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/prize-draws'} activeClassName={'active'}>
              <FormattedMessage id={'Prize Draws'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/customer-support'} activeClassName={'active'}>
              <FormattedMessage id={'Customer Support'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/raffle-images'} activeClassName={'active'}>
              <FormattedMessage id={'Raffle Images'} />
            </NavLink>
          </nav>
          <nav className="menu_nav">
            <NavLink to={'/dashboard/worldcup/reports'} activeClassName={'active'}>
              <FormattedMessage id={'Reports'} />
            </NavLink>
          </nav>
        </div>
      </div>
      <div className={'worldCup_layout_content'}>
        <div className={'worldCup_layout_content_box'}>
          <Switch>
            <Route exact path={'/dashboard/worldcup/sponsors'} component={Sponsors} />
            <Route exact path={'/dashboard/worldcup/establishments'} component={Establishments} />
            <Route exact path={'/dashboard/worldcup/prizes'} component={Prizes} />
            <Route exact path={'/dashboard/worldcup/setup'} component={Setup} />
            <Route exact path={'/dashboard/worldcup/prize-draws'} component={PrizeDraws} />
            <Route exact path={'/dashboard/worldcup/customer-support'} component={CustomerSupport} />
            <Route exact path={'/dashboard/worldcup/raffle-images'} component={RaffleImages} />
            <Route path={'/dashboard/worldcup/reports'} component={Reports} />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default WorldCup;
